export const stockType = {
  localDistributorStock: "local-distributor-stock",
  localStock: "local-stock",
  foreignStock: "foreign-stock",
  outStock: "out-stock",
  undefinedStock: "undefined-stock",
};
